
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Die Visualisierung der Daten macht die negative Entwicklung ersichtlich: In den letzten Jahren reflektierte der Wald vermehrt Licht im roten Spektralbereich, was Stress bedeutet. Je roter, desto mehr vorzeitige Laubfärbung gibt es und desto schlechter geht es der Vegetation. Je grüner, desto höher die Vitalität.`}</p>
    <p>{`«2019 befanden sich etwa 15 Prozent der Waldfläche in der Schweiz unter Stress. 2018 waren es sogar fast 30 Prozent», sagt Allan Buras, Koordinator des Waldzustandsmonitors. «Unter normalen Bedingungen sollten es nicht mehr als 5 Prozent sein.» Schon früher gab es Jahre, in denen der Wald gelitten hat. Etwa im legendäre Hitzesommer 2003, der alle Temperaturrekorde brach. Aber solche extreme Jahre haben sich in jüngster Zeit gehäuft.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;